module.exports = __webpack_public_path__ + "static/rodney-smith-2da04c91d4fb378591051bd3091f66c6.png";